import { ChatEngine } from "react-chat-engine";


import "./App.css";
import ChatFeed from "./components/ChatFeed";
import LoginForm from "./components/LoginForm";

const App = () => {

  if (!localStorage.getItem('username'))return <LoginForm/>
  return (
    <ChatEngine
      height="100vh"
      projectID="1fade515-82a1-4238-bab9-8db85434b73c"
      userName={localStorage.getItem('username')}
      userSecret={localStorage.getItem('password')}
      renderChatFeed={(ChatAppProps) => <ChatFeed {...ChatAppProps} />}
    />
  );
};

export default App;
